import { noop } from "lodash-es";

export const asyncNoop = async () => {};
export const nestedNoop = () => noop;
